import styled from 'styled-components'

import { media } from 'featureSliced/shared/utils/breakpoints'

export const FooterStyled = styled.div`
  padding: 10px 20px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 50px;
  grid-gap: 10px;

  background-color: ${({ theme }) => theme.FooterColor};
  color: ${({ theme }) => theme.FontColor};

  box-shadow: 0px 0px 7px rgba(0, 0, 0, 0.15);
  border-top: ${({ theme }) => `1px solid ${theme.ItemBorder}`};
  height: 120px;
  width: 100%;
  & button {
    height: 50px !important;
  }

  /* QRM-641: on the phone this is a bar pinned across the bottom of the screen.
     Inside the web layout's centred column it becomes the page's own footer card,
     in the flow, so it stops spanning the monitor. */
  ${media.web} {
    position: static;
    height: auto;
    border-radius: 10px;
    border: 0.5px solid ${({ theme }) => theme.ItemsBorders};
    box-shadow: none;
    padding: 16px 20px;
    grid-template-rows: auto auto;
  }
`
